import '@fontsource/source-sans-pro/latin-400.css' // -normal
import '@fontsource/source-sans-pro/latin-300.css' // -light
import '@fontsource/source-sans-pro/latin-600.css' // -semibold

export default function install(app) {
  // no-op
}
